export default __webpack_public_path__ + "static/media/breakfast_5.0ce8da50.jpg";